import { connect } from "react-redux"
import { createStructuredSelector } from "reselect"

// components
import QuicklinkWidget from "app/static/frontend/widgets/components/QuicklinkWidget"

// action creators
import { segueToUrl } from "app/static/frontend/global-action-creators"

// selectors
import {
    selectQuicklinkIsExternal,
    selectQuicklinkText,
    selectQuicklinkType,
    selectQuicklinkUrl,
} from "app/static/frontend/widgets/selectors/quicklinkWidgetSelectors"

const mapStateToProps = createStructuredSelector({
    isExternalLink: selectQuicklinkIsExternal,
    text: selectQuicklinkText,
    type: selectQuicklinkType,
    url: selectQuicklinkUrl,
})

const mapDispatchToProps = {
    segueToUrl,
}

export default connect(mapStateToProps, mapDispatchToProps)(QuicklinkWidget)
